import * as React from 'react';
import { relative } from 'path';
import reservationStore from "../../store/reservationStore";
import { useEffect } from "react";
import api from "../../utils/api";
import * as util from "../../utils/util";
import * as paymentInterface from "../../utils/paymentInterface";

import SetHospital from './SetHospital';
import SetDate from './SetDate';
import SetItem from './SetItem';
import SetPay from './SetPay';
import SetFinish from './SetFinish';
import Box from '@mui/material/Box';
import Top from "../Top";
import Bottom from "../Bottom";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import WhereToVoteOutlinedIcon from '@mui/icons-material/WhereToVoteOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { StepIconProps } from '@mui/material/StepIcon';
import { useLocation, useNavigate } from "react-router-dom";
import tabbg from "../../assets/images/tab_01.png"
import { Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { callback } from 'chart.js/dist/helpers/helpers.core';
import axios from 'axios';

export type RequestPayResponseCallback = (response: paymentInterface.RequestPayResponse) => void;

export interface Iamport {
  init: (accountID: string) => void;
  request_pay: (
    params: paymentInterface.RequestPayParams,
    callback?: RequestPayResponseCallback,
  ) => void;
}

declare global {
  interface Window {
    IMP?: Iamport;
  }
}

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 45,
  height: 45,
  display: 'flex',
  borderRadius: '50%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  top: '-15px',

  ...(ownerState.active && {

    background: '#0d670399',
    boxShadow: '0 0px 0px 8px #0d670322',
  }),
  ...(ownerState.completed && {
    background: '#0d670355',

  }),

}));

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <WhereToVoteOutlinedIcon sx={{ width: 35, fontSize: 28 }} />,
    2: <CalendarMonthOutlinedIcon sx={{ width: 35, fontSize: 28 }} />,
    3: <ChecklistOutlinedIcon sx={{ width: 35, fontSize: 28 }} />,
    4: <CreditScoreOutlinedIcon sx={{ width: 35, fontSize: 28 }} />,
    5: <CheckCircleOutlineOutlinedIcon sx={{ width: 35, fontSize: 28 }} />
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

const ReservationStep = () => {
  const storeData: any = reservationStore();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});
  const [finishSendItems, setFinishSendItems] = React.useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const companyObj = JSON.parse(localStorage.getItem("companyInfo") || '');

  const steps = [
    '병원선택',
    '검진일자선택',
    '검진항목선택',
    companyObj && companyObj.company_id == 'DUALHEALTH' ? '결제' : '예약확인',
    '예약완료'
  ];

  useEffect(() => {
    const jquery = document.createElement('script');
    jquery.src = 'https://code.jquery.com/jquery-1.12.4.min.js';
    const iamport = document.createElement('script');
    iamport.src = 'https://cdn.iamport.kr/v1/iamport.js';
    document.head.appendChild(jquery);
    document.head.appendChild(iamport);

    return () => {
      document.head.removeChild(jquery);
      document.head.removeChild(iamport);

      storeData.setReservationInfo('hosId', '');
      storeData.setReservationInfo('pkgId', '');
      storeData.setReservationInfo('addPrice', 0);
      storeData.setReservationInfo('date', '');
      storeData.setCloseItems([]);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    };
  }, []);

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let stopStep = false;
    let newSkipped = skipped;
    // 검진일자선택 => 검진항목선택 :: 예약날짜 미선택 체크
    if (activeStep === 1 && (storeData.reservationInfo.date === undefined || storeData.reservationInfo.date === null || storeData.reservationInfo.date === '')) {
      alert('예약 날짜를 선택해주세요.');
      return false;
    } else if (activeStep === 2) {
      // 검진유형, 선택/추가 검사 항목 체크 확인
      if ((storeData.choiceLimitCount !== storeData.checkedInjectioList.filter((item: any) => item.ipClass !== '추가').length)) {
        alert('[선택검사] 항목 선택이 필요합니다.');
        return false;
      } else if (storeData.choiceLimitCount === 0 && storeData.checkedInjectioList.length === 0) {
        alert('[검진유형] 선택이 필요합니다.');
        return false;
      }
    } else if (activeStep === 3) {
      stopStep = true;
      processReservation({});
    }

    if (!stopStep) {
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1));
    if (activeStep === 1) {
      storeData.setReservationInfo('date', '');
      storeData.setCloseItems([]);
    } else if (activeStep === 2) {
      storeData.setReservationInfo('date', '');
      storeData.setCloseItems([]);
      storeData.setReservationInfo('addPrice', 0);
      storeData.setReservationInfo('pkgId', 0);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    }
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const drawStepContent = (activeStep: number) => {
    if (activeStep === 0) {
      return (
        <SetHospital handleNext={handleNext} />
      )
    } else if (activeStep === 1) {
      return (
        <SetDate handleNext={handleNext} handleBack={handleBack} />
      )
    } else if (activeStep === 2) {
      return (
        <SetItem />
      )
    } else if (activeStep === 3) {
      return (
        <SetPay />
      )
    }
    else if (activeStep === 4) {
      return (
        <SetFinish finishSendItems={finishSendItems} />
      )
    }
  };

  const postMessage = (type: string, data: any) => {
    var win: any = window;
    win.ReactNativeWebView?.postMessage(JSON.stringify({ type, data }));
  };

  /*** 결제 로직 시작 **/ // TODO :: 나중에 공통 함수로 빼기
  async function processReservation(sendItems: any) {
    // const sendItems = parseSendItemsJsonObjectify(inSendItems);
    let companyInfo = JSON.parse(localStorage.getItem("companyInfo") || '');
    let FAM_INFOS = JSON.parse(localStorage.getItem("FAM_INFO") || '');
    const isRebateDirectly = String(companyInfo['is_rebate_directly']).toLowerCase() === 'true';
    const isB2C = String(companyInfo['type']).toLowerCase() === "b2c";
    const isB2B2C = parseInt(FAM_INFOS.supportPercent) < 0;
    const isB2B_supportPrice_0 = ( String(companyInfo['type']).toUpperCase() === 'B2B' && FAM_INFOS.supportPrice == 0 );
    const IS_PAYMENT = ( isRebateDirectly && (isB2C || isB2B2C || isB2B_supportPrice_0) )
    const cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');

    sendItems.userName = FAM_INFOS.famName;
    sendItems.email = FAM_INFOS.email;
    sendItems.phone = FAM_INFOS.phone;
    sendItems.address = FAM_INFOS.address;
    sendItems.buildingNum = FAM_INFOS.buildingNum;
    sendItems.zipcode = FAM_INFOS.zipcode;
    sendItems.cusId = cusId;
    sendItems.famId = storeData.reservationInfo.famId;
    sendItems.pkgId = storeData.reservationInfo.pkgId;
    sendItems.pipList = storeData.checkedInjectioList.map((item: any) => item.id);
    sendItems.firstWishDate = storeData.reservationInfo.date;
    sendItems.secondWishDate = '2099-12-31';  // TODO :: 일단 의미 없는 2차 예약일자 설정
    sendItems.additionalPrice = storeData.reservationInfo.addPrice;

    if (IS_PAYMENT) {
      await api.post(`customer/api/v2/customers/${encodeURIComponent(cusId)}/reservations/tmp/rebate/payments`, sendItems).then(res => {
        const data = res.data.data;
        const reservationTmpId = data["reservation_tmp_id"];
        const merchantUid = data["merchant_uid"];
        paymentIAMPORT(reservationTmpId, sendItems, companyInfo, merchantUid);
      }).catch(function (error) {
        console.log(error)
      });
    } else {
      await api.post('customer/api/v1/CU_003_005', sendItems).then(res => {
        sendItems.reservationId = res.data.data['reservation_id'];
        setFinishSendItems(sendItems);
        // 예약 완료 메세지 푸쉬 알림
        /*postMessage('PushAlarm', JSON.stringify({
          title: '듀얼헬스'
          , contents: `[건강 검진] ${sendItems.userName}님 ${sendItems.firstWishDate} 일자로 예약 접수 되었습니다.`
        }));*/

        // 예약 완료 알림톡
        sendAT(IS_PAYMENT);

        navigate('/MyPage/ReservationView');
      }).catch(function (error) {
        console.log(error)
      });
    }
  }

  // 알림톡 관련 api
  const bizppurio = axios.create({
    baseURL: 'https://api.dualhealth.kr/nodes/bizppurio',
    timeout: 5000
  })

  // 알림톡 함수
  async function sendAT( isPayment : Boolean ) {

    let companyInfo = JSON.parse(localStorage.getItem("companyInfo") || '');
    let FAM_INFOS = JSON.parse(localStorage.getItem("FAM_INFO") || '');
    let HOS_INFO = JSON.parse(localStorage.getItem("HOS_INFO") || '');

    const data = {
      type: companyInfo['type'],
      company_id: companyInfo['company_id'],
      company_name: companyInfo['company_name'],
      is_rebate_directly: isPayment,
      rebate_price: companyInfo['rebate_price'],
      userName: FAM_INFOS['famName'],
      phone: FAM_INFOS['phone'],
      hospital_name: HOS_INFO['name'],
      package_name: storeData.pakageInfo && storeData.pakageInfo.result.name,
      firstWishDate: storeData.reservationInfo && storeData.reservationInfo.date,
      price: storeData.reservationInfo && storeData.reservationInfo.groudPrice,
    }

    const info = {
      service: {
        "type": data.type.toLowerCase(),
        "target": data.company_id.includes("#") || data.company_id.toLowerCase() === "dualhealth" ? "customer" : data.company_id.toLowerCase(),
        "name": "건강검진"
      },
      "company": {
        "name": data.company_name,
        "isRebateDirectly": data.is_rebate_directly,
        "rebatePrice": data.rebate_price
      },
      "family": {
        "name": data.userName,
        "phone": data.phone.replaceAll(/[^\d]/ig, "")
      },
      "reservation": {
        "hospitalName": data.hospital_name,
        "packageName": data.package_name,
        "firstWishDate": data.firstWishDate,
        "secondWishDate": '-',
        "confirmedDate": null,
        "priceToPay": data.price
      }
    }
    const sendMSG: any = await bizppurio.post('/v1/message?msg=reservation_register', info).catch(e => alert("알림톡 전송에 실패했습니다."));
    return sendMSG.data;
  }

  let tempReservationTmpId = '';
  async function paymentIAMPORT(reservationTmpId: any, sendItems: any, companyInfo: any, merchantUid: any) {
    const payParam = getPayParam(companyInfo, reservationTmpId, merchantUid, sendItems);
    const userCode = process.env.REACT_APP_IMP_SID || '';

    if (isReactNative()) {
      /* 리액트 네이티브 환경에 대응하기 */
      const params = {
        userCode,                                   // 가맹점 식별코드
        payParam                                    // 결제 데이터
      };
      const paramsToString = JSON.stringify(params);
      postMessage('Iamport', paramsToString);
      navigate('/MyPage/ReservationView');
    } else {
      /* 그 외 환경의 경우 */
      /* 가맹점 식별하기 */
      const { IMP } = window;
      IMP?.init(process.env.REACT_APP_IMP_SID || '');

      tempReservationTmpId = reservationTmpId;
      IMP?.request_pay(payParam, callback); // callback 함수 호출 안됨.
    }
  }

  function callback(rsp: any) {
    let FAM_INFOS = JSON.parse(localStorage.getItem("FAM_INFO") || '');
    const reservationTmpId = encodeURIComponent(tempReservationTmpId);
    const familyId = encodeURIComponent(storeData.reservationInfo.famId);
    const impUid = rsp.imp_uid;
    const merchantUid = rsp.merchant_uid;
    const success = rsp.success;
    const userName = FAM_INFOS.famName;
    const wishDate = storeData.reservationInfo.date;

    // 포트원 결제 정상 처리
    if (success === true) {
      // 임시 저장 상태인 예약 정보를 온전한 예약 상태로 저장
      api.post(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/${impUid}/payments/${merchantUid}?family_id=${familyId}`, []).then(res => {
        if (res.data.message.toString().toLowerCase() === "success" || res.data.success.toString().toLowerCase() === "true") {
          alert("결제가 완료되었습니다.");
          // 예약 완료 메세지 푸쉬 알림
          /*postMessage('PushAlarm', JSON.stringify({
            title: '듀얼헬스'
            , contents: `[건강 검진] ${userName}님 ${wishDate} 일자로 예약 접수 되었습니다.`
          }));*/

          // 예약 완료 알림톡 ( 결제 )
          sendAT(true);

          navigate('/MyPage/ReservationView');
        } else {
          throw Error(res.data.message);
        }
      }).catch(function (error) {
        console.log(error)
      });
    } else {
      // 임시 저장 상태인 예약 정보 삭제
      alert("결제 중 오류가 발생하였습니다.");
      api.delete(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/payments/${merchantUid}`).then(res => {
        navigate('/reservation');
      }).catch(function (error) {
        console.log(error)
      });
    }

  }

  function isReactNative() {
    /*
      리액트 네이티브 환경인지 여부를 판단해
      리액트 네이티브의 경우 IMP.payment()를 호출하는 대신
      리액트 네이티브로 post message를 보낸다

      아래 예시는 모든 모바일 환경을 리액트 네이티브로 인식한 것으로
      실제로는 user agent에 값을 추가해 정확히 판단해야 한다
    */
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      // mobile
      return true;
    } else {
      // desktop
      return false;
    }
  }

  function getPayParam(companyInfo: any, reservationTmpId: any, merchantUid: any, sendItems: any) {
    const customerUid = `${sendItems.cusId}-${sendItems.famId}`;
    const buyerAddress = `${sendItems.address} ${sendItems.buildingNum}`;
    const buyerPostcode = sendItems.zipcode;
    const buyerName = sendItems.userName;
    const buyerEmail = util.isEmail(sendItems.email) ? sendItems.email : '';
    const buyerTel = sendItems.phone;
    const paymentPrice = companyInfo.rebate_price;
    const productName = '듀얼헬스케어';
    // iamport 결제 진행 후 callback 함수가 실행되지 않고 해당 URL(결제 검증 화면)로 이동 함
    const mRedirectionUrl = `${window.location.protocol}//${window.location.host}/reservation/SetPayValidation?reservationTmpId=${reservationTmpId}&family_id=${encodeURIComponent(sendItems.famId)}&userName=${sendItems.userName}&wishDate=${sendItems.firstWishDate}`;
    const webhook = process.env.REACT_APP_WEBHOOK || '';

    return {
      pg: `html5_inicis.` + (process.env.REACT_APP_PGMID || ''),
      pay_method: 'card', // 'card'만 지원
      merchant_uid: merchantUid,
      app_scheme: '',
      name: productName, //상품명
      amount: paymentPrice,
      // customer_uid: customerUid, 비인증 결제용 파라미터
      buyer_email: buyerEmail,
      buyer_name: buyerName,
      buyer_tel: buyerTel,
      buyer_addr: buyerAddress,
      buyer_postcode: buyerPostcode,
      m_redirect_url: mRedirectionUrl,
      notice_url: webhook
    }
  }

  /*
  function setPaymentResponseIn(sendItems:any, rsp:any){
    try {
      let paymentResponse = {merchantUid: '', impUid: '', payMethod: '', amount: '', status: '', pgProvider: '', pgTid: ''};
      paymentResponse.merchantUid = rsp.merchant_uid;
      paymentResponse.impUid = rsp.imp_uid;
      paymentResponse.payMethod = rsp.pay_method;
      paymentResponse.amount = rsp.paid_amount;
      paymentResponse.status = rsp.status;
      paymentResponse.pgProvider = rsp.pg_provider;
      paymentResponse.pgTid = rsp.pg_tid;
      sendItems.paymentResponse = paymentResponse;
    } catch (e) {
    }
    return sendItems;
  }
  
  async function checkAndSavePayment( reservationTmpId:any, merchantUid:any, impUid:any, famId:any){
    api.post(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/${impUid}/payments/${merchantUid}?family_id=${encodeURIComponent(famId)}`, []).then(res => {
      if ( res.data.message.toString().toLowerCase() === "success" ||  res.data.success.toString().toLowerCase() === "true" ) {
        return res.data;
      }else {
        throw Error(res.data.message);
      }
    }).catch(function (error) {
      console.log(error)
    });
  }
    
  async function delReservationOfCanceledPayment ( reservationTmpId:any, merchantUid:any ){
    api.delete(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/payments/${merchantUid}`).then(res => {
      if ( res.data.success.toString().toLowerCase() !== "true" ) throw Error(res.data.message);
    }).catch(function (error) {
      console.log(error)
    });
  }
  */
  /*** 결제 로직 종료 **/


  const img = {
    backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2, width: '100%', height: 200
  }

  return (
    <Container className='container'>
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#b2f7ab', fontWeight: 900, }}>
              예약서비스
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ee725', fontWeight: 500, }} gutterBottom>
              검진예약
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ position: 'relative', width: '80%', ml: 'auto', mr: 'auto', '& .MuiContainer-root': { p: 0, maxWidth: '100%' } }}>
        <Typography sx={{ mt: 0, mb: 3, fontSize: '20px' }} textAlign={'center'}>
          검진예약절차
        </Typography>

        <Stepper alternativeLabel activeStep={activeStep} sx={{ bgcolor: '#fff', p: '40px 0 20px', border: '1px solid #eee', borderRadius: 5 }}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label}>
                <StepLabel StepIconComponent={ColorlibStepIcon} sx={{ '& .MuiStepLabel-alternativeLabel': { mt: '2px!important' } }}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>

        {allStepsCompleted() ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
          </React.Fragment>
        ) : (
          drawStepContent(activeStep)
        )}

        <MobileStepper
          variant="progress"
          steps={steps.length + 1}
          position="static"
          activeStep={activeStep}
          sx={{
            width: '100%', flexGrow: 1, p: '0 20px 40px 20px', mb: 10, mt: 3, bgcolor: '#F6F6F6', boxSizing: 'border-box', display: activeStep === 0 || activeStep === 4 ? 'none' : 'flex',
            '& .MuiLinearProgress-root': { display: 'none' }
          }}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={activeStep === 5} sx={stepNextBtn}>
              {activeStep === 3 || activeStep === 4 ? "완료" : "Next"}
              {theme.direction === 'rtl' ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={activeStep === 0} sx={stepNextBtn}>
              {theme.direction === 'rtl' ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              Back
            </Button>
          }
        />
      </Box>
      <Bottom />
    </Container>
  );
}
const stepNextBtn = {
  bgcolor: '#fff',
  color: '#0d6703',
  borderRadius: '30px',
  border: '1px solid #0d6703',
  width: '48%',
  p: '10px'


}





export default ReservationStep;